import React from 'react'

import { Card, RadioButton, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { WizardData } from 'modules/procurement/components/purchaseOrders/UpdateOrderModal/types'

interface Props {
  selected?: boolean
}

const ManualPaymentOption: React.FC<
  Pick<WizardStepRenderParams<WizardData>, 'data' | 'onDataChanged'> & Props
> = ({ selected, data, onDataChanged }) => {
  const handleSelected = () => {
    onDataChanged({
      ...data,
      preferredPaymentMethod: 'cash',
    })
  }

  return (
    <Card onClick={handleSelected}>
      <Card.Title
        action={
          <RadioButton
            value="cash"
            checked={!!selected}
            onChange={(event) => event.target.value === 'cash' && handleSelected()}
          />
        }
      >
        {i18n.t(
          'procurement.purchase_orders.update_order_wizard.steps.payment_method.options.manual_payment.title'
        )}
      </Card.Title>
      <Card.Description>
        {i18n.t(
          'procurement.purchase_orders.update_order_wizard.steps.payment_method.options.manual_payment.description'
        )}
      </Card.Description>
    </Card>
  )
}

export default ManualPaymentOption
